module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/fac-step3-4b314368ba0e5a2f073e760cd2523004.svg";